












































































































































































































































































































import Vue from '@front-app/vendor/vue';
import {
	ref,
	computed,
	onUnmounted,
	defineComponent,
	reactive,
	Ref,
	PropType,
	toRef,
	toRefs,
	onMounted,
	watch,
	watchEffect,
} from '@vue/composition-api';
import CtaButton from '@front-app/components/buttons/CtaButton.vue';
import TrForm from '@front-app/components/form/Form.vue';
import FormSection from '@front-app/components/form/FormSection.vue';
import FormInput from '@front-app/components/form/FormInput.vue';
import FormLabel from '@front-app/components/form/FormLabel.vue';
import FormError from '@front-app/components/form/FormError.vue';
import EditorMenu from '@front-app/components/form/tiptap/EditorMenu.vue';
import EditorContent from '@front-app/components/form/tiptap/EditorContent.vue';
import EditorContainer from '@front-app/components/form/tiptap/EditorContainer.vue';
import { EditorOptions, useTiptapEditor, EMPTY_MESSAGE } from '@front-app/components/form/tiptap/useTiptapEditor';
import IconButton from '@front-app/components/buttons/IconButton.vue';
import visible from '@front-app/directives/visible';
import { detectVideoProvider, VideoProvider } from '@front-app/components/video/util';
import { scrollTo } from '@front-app/directives/scrollTo';
import { Groups } from '@front-app/services/GroupsApi/GroupModel';
import { STATUS } from '@front-app/constants/state';
import { verifyUrl } from '@front-app/services/UrlApi/UrlApi';
import { UrlInfo } from '@front-app/services/UrlApi/UrlInfoModel';
import { required } from '@front-app/components/form/validation/validators';
import {
	FieldValidationSchema,
	SchemaName,
	V,
	v,
	ValidationRule,
} from '@front-app/components/form/validation/useValidation';
import { Editor } from '@tiptap/core';
import { useConfirmDialog } from '@vueuse/core';
import { Spacing, Size } from '@front-app/components/constants';
import { useRemoveFromArray } from '@front-app/hooks/useRemoveFromArray';
import { useAsyncStatus } from '@front-app/hooks/useAsyncStatus';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { ButtonPalettes } from '@front-app/components/buttons/palettes';
import { useThrottledUsersSearch } from '@front-app/hooks/ThrottledApi/userSearch';
import { CurrentUserStore, UserAvatarStore } from '@front-app/store/singletons/User';
import { useTranslate, useUsername } from '@front-app/hooks/useTranslate';
import TrCheckbox from '@front-app/components/inputs/Checkbox.vue';
import SimpleCard from '@front-app/components/cards/SimpleCard.vue';
import LoaderState from '../LoaderState.vue';
import CategoriesInput from '../inputs/CategoriesInput.vue';
import ConfirmationModal from '../modals/ConfirmationModal.vue';
import { LINK } from '../form/tiptap/marks';
import MentionList from '../form/tiptap/MentionList.vue';

export default defineComponent({
	directives: {
		visible,
		scrollTo,
	},
	components: {
		SimpleCard,
		CtaButton,
		TrForm,
		FormInput,
		FormLabel,
		FormError,
		FormSection,
		TrCheckbox,
		EditorMenu,
		EditorContent,
		EditorContainer,
		FontAwesomeIcon,
		IconButton,
		LoaderState,
		CategoriesInput,
		ConfirmationModal,
		MentionList,
	},
	props: {
		groups: {
			type: Array as PropType<Groups>,
			default: () => [],
		},
		excludedGroups: {
			type: Array as PropType<Groups>,
			default: () => [],
		},
		submissionStatus: {
			type: String as PropType<STATUS>,
			default: STATUS.UNSTARTED,
		},
		categories: {
			type: Array as PropType<string[]>,
			default: () => [],
		},
		showGroupList: Boolean,
		disableAtMentions: Boolean,
		disableFollowButton: Boolean,
		isReply: Boolean,
		canAddNewCategories: Boolean,
	},
	setup(props, ctx) {
		const el = ref(null as null | Element);
		const getNotifyMembersDefault = () => props.groups.length === 1
			&& props.groups[0].adminSettings.notifyAllMembersDiscussionDefault;
		const isNotifyAllMembersEnabled = computed(() => props.groups.length !== 1
			|| props.groups[0].adminSettings.notifyAllMembersDiscussionEnabled);
		const state = reactive({
			subjectText: '',
			message: '',
			following: !props.disableFollowButton,
			notifyMembers: getNotifyMembersDefault(),
		});
		const resetState = () => {
			state.subjectText = '';
			state.message = '';
			state.following = !props.disableFollowButton;
			state.notifyMembers = getNotifyMembersDefault();
		};

		onMounted(() => {
			const val = el.value;
			if (!val) {
				return;
			}
			const inputEl = (val as unknown as Vue).$el.querySelector('#subject') as HTMLInputElement | null;
			if (!inputEl) {
				return;
			}
			inputEl.focus();
			inputEl.scrollIntoView();
		});

		// Categories
		const selectedCategories = reactive([]);
		const removeSelectedCategory = useRemoveFromArray(selectedCategories);
		const selectedNewCategories = reactive([]);
		const removeSelectedNewCategory = useRemoveFromArray(selectedNewCategories);
		// END Categories

		// at-mentions
		// eslint-disable-next-line arrow-body-style
		const firstGroupId = computed(() => {
			return props.groups.length > 0 ? props.groups[0].id : '';
		});
		const getUsernameInternal = useUsername(ctx);
		const searchGroupUsers = useThrottledUsersSearch();

		const {
			track: trackMentionFetch,
			status: mentionFetchStatus,
		} = useAsyncStatus();
		// At-mentions should be disabled when posting to multiple groups at once as we have no way to vet the userlist currently
		const editorConfig: EditorOptions = props.groups.length > 1 ? {} : {
			atMentionConfig: {
				translationService: useTranslate(ctx),
				mentionProvider: ({ query }) => trackMentionFetch(searchGroupUsers.search(firstGroupId.value, { name: query, limit: 5 })),
			},
		};

		const {
			editor,
			selectMention,
			mentionItems,
			mentionListRef,
		} = useTiptapEditor(el, editorConfig);
		// END at-mentions

		const getValidationScheme = () => {
			if (props.isReply) {
				return v({
					message: {
						value: toRef(state, 'message'),
						rules: [required()],
					},
				});
			}
			return v({
				subject: {
					value: toRef(state, 'subjectText'),
					rules: [required()],
				},
				message: {
					value: toRef(state, 'message'),
					rules: [required()],
				},
			});
		};
		const validation = getValidationScheme();

		// Link attachments
		const $t = useTranslate(ctx);
		const linkIds: Ref<string[]> = ref([]);
		const attachedLinkIds: Ref<string[]> = ref([]);
		const links: Record<string, UrlInfo> = {};
		const linkValidators: Record<string, V<LinkValidationSchema>> = {};

		const getAttachmentLabel = (url: string) => {
			const detectedProvider = detectVideoProvider(url);
			if (detectedProvider === VideoProvider.YOUTUBE || detectedProvider === VideoProvider.VIMEO) {
				// eslint-disable-next-line consistent-return
				return $t('discussion_form.attachment-field.add-to-content-page-label-embedded');
			}
			// eslint-disable-next-line consistent-return
			return $t('discussion_form.attachment-field.add-to-content-page-label');
		};

		const onUpdate = ({ editor: localEditor }: { editor: Editor }) => {
			localEditor.state.doc.descendants((node) => {
				node.marks
					// eslint-disable-next-line eqeqeq
					.filter((mark) => mark.type.name == LINK)
					.forEach(async (mark) => {
						const { id } = mark.attrs;
						const href = mark.attrs.href.trim();

						if (!id || linkIds.value.includes(id)) {
							return;
						}

						links[id] = reactive(new UrlInfo());
						links[id].requestedUrl = href;

						linkValidators[id] = getLinkValidator(links[id]);

						linkIds.value = [...linkIds.value, id];
						const result = await verifyUrl(href);
						if (!result.isSuccess) {
							links[id].status = STATUS.ERROR;
						} else {
							Object.assign(links[id], result);
							links[id].status = STATUS.SUCCESS;
						}
					});

				return true;
			});
		};

		const removeLink = (linkId: string) => {
			linkIds.value = linkIds.value.filter((id) => id !== linkId);
			attachedLinkIds.value = attachedLinkIds.value.filter((id) => id !== linkId);
		};
		const toggleLinkAttachment = (linkId: string) => {
			if (attachedLinkIds.value.includes(linkId)) {
				attachedLinkIds.value = attachedLinkIds.value.filter((id) => id !== linkId);
			} else {
				attachedLinkIds.value = attachedLinkIds.value.concat(linkId);
			}
		};
		const areAllAttachmentsSelected = computed(() => {
			const attached = attachedLinkIds.value;
			return linkIds.value.every((id) => attached.includes(id));
		});
		const toggleAllAttachments = () => {
			if (areAllAttachmentsSelected.value) {
				attachedLinkIds.value = [];
			} else {
				attachedLinkIds.value = Array.from(linkIds.value);
			}
		};
		const validateLinkName = (id: string) => {
			linkValidators[id].fields.name.validate();
		};
		const isLinkNameValid = (id: string) => !attachedLinkIds.value.includes(id) || linkValidators[id].fields.name.isValid;
		const validateAllAttachedLinks = () => {
			attachedLinkIds.value.forEach((id) => {
				linkValidators[id].validate();
			});
		};

		const clearAllLinks = () => {
			linkIds.value = [];
			attachedLinkIds.value = [];
		};
		// END Link attachments

		editor.on('update', onUpdate);
		onUnmounted(() => {
			editor.off('update', onUpdate);
		});

		const updateMessage = () => {
			state.message = editor.getHTML();
			if (state.message === EMPTY_MESSAGE) {
				state.message = '';
			}
			ctx.emit('edit', state.message);
		};
		editor.on('blur', async () => {
			updateMessage();
			await ctx.root.$nextTick();
			await ctx.root.$nextTick();
			validation.fields.message.validate();
		});

		const confirmDiscussions = useConfirmDialog();
		confirmDiscussions.onConfirm(createDiscussionsStep2);
		const createDiscussions = async () => {
			updateMessage();
			validation.validate();
			validateAllAttachedLinks();
			const hasInvalidAttachedLinks = !attachedLinkIds.value
				.map((id) => linkValidators[id])
				.every((validator) => validator.isValid.value);
			if (!validation.isValid.value || hasInvalidAttachedLinks) {
				return;
			}
			if (props.groups.length > 1) {
				confirmDiscussions.reveal();
			} else {
				createDiscussionsStep2();
			}
		};
		function createDiscussionsStep2() {
			const attachedLinks = attachedLinkIds.value.map((id) => links[id]);
			ctx.emit('create-discussions', {
				links: attachedLinks,
				messageText: editor.getHTML(),
				categories: [].concat(selectedNewCategories, selectedCategories),
				...state,
			});
		}

		watchEffect(() => {
			UserAvatarStore.fetch(CurrentUserStore.currentUser.value.id);
		});

		// Status...
		const clearForm = () => {
			resetState();
			editor.chain().setContent(EMPTY_MESSAGE).run();
			clearAllLinks();
		};
		const isLoading = computed(() => props.submissionStatus === STATUS.LOADING);
		watch(() => props.submissionStatus, (newVal: STATUS, oldVal: STATUS) => {
			if (newVal === oldVal || newVal !== STATUS.SUCCESS) {
				return;
			}
			clearForm();
		});

		return {
			...toRefs(state),
			Spacing,
			Size,
			LOADING: STATUS.LOADING,
			createDiscussions,
			confirmDiscussions,
			validation,
			el,
			editor,
			ButtonPalettes,
			// popupContent,
			isLoading,
			isNotifyAllMembersEnabled,
			// Links
			getAttachmentLabel,
			linkIds,
			attachedLinkIds,
			links,
			removeLink,
			toggleLinkAttachment,
			areAllAttachmentsSelected,
			toggleAllAttachments,
			validateLinkName,
			isLinkNameValid,
			// Categories
			selectedCategories,
			removeSelectedCategory,
			selectedNewCategories,
			removeSelectedNewCategory,
			// At mentions
			mentionFetchStatus,
			selectMention,
			mentionItems,
			mentionListRef,
			getUsername: getUsernameInternal,
			currentUser: CurrentUserStore.currentUser,
		};
	},
});

interface LinkNameValidationSchema extends FieldValidationSchema<string> {
	values: Ref<string>;
	rules: ValidationRule<string>[];
}

interface LinkValidationSchema extends Record<SchemaName, FieldValidationSchema<string>> {
	name: LinkNameValidationSchema;
}

function getLinkValidator(link: UrlInfo): V<LinkValidationSchema> {
	return v({
		name: {
			value: toRef(link, 'pageTitle'),
			rules: [required()],
		},
	});
}
